import _ from "underscore";
import { getDictionary, getUsers } from "./api";
import { fullUserName } from "@/utils/user";

async function getDataSource(getFunc) {
  return {
    store: {
      type: "array",
      data: await getFunc(),
      key: "id"
    }
  };
}

let plants;
let units;
let itemTypes;
let itemGroups;
let users;

export async function getPlants() {
  if (plants) {
    return plants;
  }
  plants = await getDictionary("PLANT");
  plants.forEach(rec => {
    _.extend(rec, { value: rec.id, text: rec.name });
  });
  return plants;
}
export const getPlantDataSource = async () => getDataSource(getPlants);

export async function getUnits() {
  if (units) {
    return units;
  }
  units = await getDictionary("UNIT");
  units.forEach(rec => {
    _.extend(rec, { value: rec.id, text: rec.code });
  });
  return units;
}
export const getUnitDataSource = async () => getDataSource(getUnits);

export async function getItemTypes() {
  if (itemTypes) {
    return itemTypes;
  }
  itemTypes = await getDictionary("ITEM_TYPE");
  itemTypes.forEach(rec => {
    _.extend(rec, { value: rec.id, text: rec.name });
  });
  return itemTypes;
}
export const getItemTypeDataSource = async () => getDataSource(getItemTypes);

export async function getItemGroups() {
  if (itemGroups) {
    return itemGroups;
  }
  itemGroups = await getDictionary("ITEM_GROUP");
  itemGroups.forEach(rec => {
    _.extend(rec, { value: rec.id, text: rec.name });
  });
  itemGroups.sort((a,b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  return itemGroups;
}
export const getItemGroupDataSource = async () => getDataSource(getItemGroups);

export const getUserDataSource = async function (){
  if (!users) {
    users = await getUsers();
    users.forEach(rec => _.extend(rec, { value: rec.id, text: fullUserName(rec) }));
  }
  return {
    store: {
      type: "array",
      data: users,
      key: "id"
    }
  }
}
